module.exports = __webpack_public_path__ + "static/media/400136_02.1bc9b9bf.png";